import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const workScheduleDescriptor = defineListFilter({
  definition: {
    id: FilterId.WORK_SCHEDULE,
    name: 'Work Schedule',
    selectionListId: 'work_schedule',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_WORK_SCHEDULE },
});
